// extracted by mini-css-extract-plugin
export default {"photoImage":"overlayImage_photoImage__YC1gs","overlay":"overlayImage_overlay__xcEjd"};